<template>
  <div class="otherInfo">
    <div style="padding: 10px 10px; color: #fff" class="d-flex">
      <Link :underline="false" class="ml-auto" @click="$emit('closeTab')">
        <svgicon name="cancelwhite" width="12" height="12"/>
      </Link>
    </div>

    <div v-for="(field, index) in visibleFields" :key="field.name">
      <div class="newcardblock" v-if="field.visible_to_transporter">
        <div class="row labelgrid">
          <div class="col-5 no-padding">
            <div class="primarylabel">
              <span>{{ field.label }} <span v-if="isRequired(field)" class="asterisk">*</span></span>
            </div>
          </div>
          <div class="col-7 floatright no-padding">
            <div class="divcardblock">
              <Input v-if="field.type === 'text' || field.type === 'number'"
                :type="field.type"
                :class="{ 'errorfield': showError(field) }"
                :placeholder="`Enter ${field.label && field.label.toLowerCase()}`"
                :disabled="!field.editable_to_transporter"
                v-model="field.value"
                @input="emitValidationChange"
                @wheel="$event.target.blur()"
                @keydown="preventDefault($event)" />

              <SwitchBtn v-else-if="field.type === 'boolean'"
                :value="field.value"
                :disabled="!field.editable_to_transporter"
                :label="field.label"
                active-text="YES"
                inactive-text="NO"
                active-value="YES"
                inactive-value="NO"
                class="default-switch"
                @change="val => handleSwitchChange(field, val)" />

              <div v-else-if="field.type === 'date'" class="datepickerblock calenderstyle calender-dark">
                <div class="datepicker-trigger">
                  <span :id="`datepicker-trigger-${index}`" class="text-white">
                    {{ field.value || `Select ${field.label && field.label.toLowerCase()}` }}
                  </span>
                  <AirbnbStyleDatepicker
                    v-if="field.editable_to_transporter"
                    :trigger-element-id="`datepicker-trigger-${index}`"
                    mode="single"
                    :months-to-show="2"
                    :date-one="field.value"
                    @date-one-selected="val => handleDateChange(field, val)" />
                  <svgicon name="fill_arrow" class="icon" width="10" height="10" :original="true" />
                </div>
              </div>
            </div>

            <span v-if="showError(field)" class="errormessagetext">
              <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
              {{ $t('PAY_CANNOT_BE_BLANK') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceCustomFields',
  props: {
    customFields: {
      type: Array,
      default: () => [],
    },
    clickedSubmit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleFields() {
      return this.customFields.filter(field => field.visible_to_transporter).map((field) => {
        if (field.value === undefined || field.value === null) {
          this.$set(field, 'value', field.type === 'boolean' ? '0' : '');
        }
        return field;
      });
    },
    allRequiredFieldsValid() {
      return this.customFields.every(field =>
        !this.isRequired(field) || (field.value && field.value.toString().trim()),
      );
    },
  },
  watch: {
    customFields: {
      handler() {
        this.$emit('validationChange', this.allRequiredFieldsValid);
      },
      deep: true,
    },
  },
  methods: {
    isRequired(field) {
      return field.required && field.editable_to_transporter;
    },
    showError(field) {
      return this.clickedSubmit && this.isRequired(field) && !field.value;
    },
    handleDateChange(field, val) {
      this.$set(field, 'value', val);
      this.emitValidationChange();
    },
    handleSwitchChange(field, val) {
      if (!field.editable_to_transporter) return;
      this.$set(field, 'value', val === 'YES' || val === 1 ? 'YES' : 'NO');
      this.emitValidationChange();
    },
    emitValidationChange() {
      this.$emit('validationChange', this.allRequiredFieldsValid);
    },
    preventDefault(event) {
      event.stopPropagation();
    },
    getValues() {
      return this.customFields.reduce((acc, field) => {
        if ((field.type === 'boolean' && !field.editable_to_transporter) ||
            !field.value || !field.value.toString().trim()) return acc;
        acc[field.name] = field.value;
        return acc;
      }, {});
    }
  }
};
</script>

<style scoped lang="scss">
.otherInfo{
  background: rgba(36, 36, 47, 0.8);
  height: 100%;
  .newcardblock{
    padding-bottom: 0;
  }
}

.errorfield input {
  border: 1px solid #EB5D58 !important;
}
</style>
